import { BackendService } from './services/backend.service';
import { Tombstone } from './models/Tombstone';
import { FirebaseService } from './services/firebase.service';
import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Photo } from './models/Photo';
import { Person } from './models/Person';
import { CemeterySelectedService } from './services/cemetery-selected.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  providers: [CemeterySelectedService],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  constructor(private cemeterySelectedService: CemeterySelectedService) {}

  sendFilterCemeteryEvent(value) {
    this.cemeterySelectedService.setSelectedCemetrieis(value);
  }
}
